import { all } from "axios";
import { useLanguage } from "../context/LanguageContext";
import { Card, Spinner } from "react-bootstrap";

export default function withLanguage(WrappedComponent) {
  return function WithLanguage(props) {
    const { languages, loading } = useLanguage();
    const { data, idField, ...rest } = props;

    // If no valid data, render normally
    if (!data || typeof data !== "object") {
      return (
        <WrappedComponent {...rest} data={data ?? ""} idField={idField} />
      );
    }

    // Show loading spinner if API is loading
    if (loading) {
      return (
        <Card className="mt-2">
          <Card.Body>
            <div className="text-center p-3">
              <Spinner animation="border" />
            </div>
          </Card.Body>
        </Card>
      );
    }

    // Handle no languages fetched
    if (
      !languages ||
      !languages.defaultLanguage ||
      !Array.isArray(languages.availableLanguages)
    ) {
      return (
        <WrappedComponent {...rest} data={data ?? ""} idField={idField} />
      );
    }

    // Combine default + available languages
    const allLanguages = [
      { ...languages.defaultLanguage, isDefault: true },
      ...languages.availableLanguages.filter(
        (lang) => lang.code !== languages.defaultLanguage.code
      ),
    ];

    const count = allLanguages.length;

    return (
      <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
        {allLanguages.map((lang) => {
          const langKey =
            count === 1 ? "@none" : (lang.code || "@none").toLowerCase();

          // Safe string fallback
          const langData =
            typeof data[langKey] === "string"
              ? data[langKey]
              : lang.isDefault && typeof data["@none"] === "string"
              ? data["@none"]
              : "";

          const langIdField = idField.replace("@none", langKey);
          const languageLabel = langKey;

          return (
            <div
              key={langKey}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              {/* Language Label */}
              {allLanguages.length > 1 && (
                <span
                  style={{
                    minWidth: "30px",
                    fontWeight: "600",
                    color: "#333",
                  }}
                >
                  {languageLabel}:
                </span>
              )}

              {/* Wrapped Component */}
              <div style={{ flex: 1 }}>
                <WrappedComponent
                  {...rest}
                  data={langData}
                  idField={langIdField}
                />
              </div>
            </div>
          );
        })}
      </div>
    );
  };
}
